module.exports = __webpack_public_path__ + "img/cc-mbs-square-black.8fac2dae.png";